export const LANGUAGE_TOGGLE_DESCRIPTION = 'Toggle to change language'
